
import SmsList from './src/sms/SmsList.vue' //短信发送列表
import SmsDetail from './src/sms/SmsDetail.vue' //短信发送列表 

let views = {
  SmsList,
  SmsDetail
};

export default views;